export function Checkmark() {
  return (
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 33 32" fill="none">
<path d="M24.7047 10.5123C25.281 11.116 25.2587 12.0725 24.655 12.6488L14.8772 21.9821C14.5827 22.2632 14.1872 22.4136 13.7804 22.3992C13.3735 22.3848 12.9896 22.2068 12.7157 21.9055L8.27129 17.0167C7.7099 16.3991 7.7554 15.4435 8.37294 14.882C8.99047 14.3207 9.94617 14.3661 10.5076 14.9837L13.9104 18.7269L22.5683 10.4626C23.1719 9.88639 24.1284 9.90863 24.7047 10.5123Z" fill="currentColor"/>
</svg>
  );
}
